var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Checkmark>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1C5.92452 1 1 5.92452 1 12C1 18.0755 5.92452 23 12 23C18.0755 23 23 18.0755 23 12C23 5.92452 18.0755 1 12 1ZM16.748 7.12297L18.2522 8.49797L10.0022 17.6287L5.74798 13.3744L7.18757 11.9349L9.87304 14.6203L16.748 7.12236L16.748 7.12297Z",
    fill: "#6E6E6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteInactiveIcon);
export default __webpack_public_path__ + "static/media/CompleteInactiveIcon.d4913186303ab6e1a93c3faa048ef2a7.svg";
export { ForwardRef as ReactComponent };